/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Campaigns_Mag7_Spacex_Cta_LabelInputs */

const en_campaigns_mag7_spacex_cta_label = /** @type {(inputs: Campaigns_Mag7_Spacex_Cta_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open Mag7X Strategy`)
};

const de_campaigns_mag7_spacex_cta_label = /** @type {(inputs: Campaigns_Mag7_Spacex_Cta_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mag7X-Strategie öffnen`)
};

const pt_br2_campaigns_mag7_spacex_cta_label = /** @type {(inputs: Campaigns_Mag7_Spacex_Cta_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir Estratégia Mag7X`)
};

const tr_campaigns_mag7_spacex_cta_label = /** @type {(inputs: Campaigns_Mag7_Spacex_Cta_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mag7X Stratejisini Aç`)
};

const zh_cn2_campaigns_mag7_spacex_cta_label = /** @type {(inputs: Campaigns_Mag7_Spacex_Cta_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打开 Mag7X 策略`)
};

const zh_hk2_campaigns_mag7_spacex_cta_label = /** @type {(inputs: Campaigns_Mag7_Spacex_Cta_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開啟 Mag7X 策略`)
};

const ko_kr2_campaigns_mag7_spacex_cta_label = /** @type {(inputs: Campaigns_Mag7_Spacex_Cta_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mag7X 전략 열기`)
};

const ru_ru2_campaigns_mag7_spacex_cta_label = /** @type {(inputs: Campaigns_Mag7_Spacex_Cta_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Открыть стратегию Mag7X`)
};

const es_419_campaigns_mag7_spacex_cta_label = /** @type {(inputs: Campaigns_Mag7_Spacex_Cta_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir estrategia Mag7X`)
};

/**
* | output |
* | --- |
* | "Open Mag7X Strategy" |
*
* @param {Campaigns_Mag7_Spacex_Cta_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const campaigns_mag7_spacex_cta_label = /** @type {((inputs?: Campaigns_Mag7_Spacex_Cta_LabelInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Campaigns_Mag7_Spacex_Cta_LabelInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_campaigns_mag7_spacex_cta_label(inputs)
	if (locale === "de") return de_campaigns_mag7_spacex_cta_label(inputs)
	if (locale === "pt-BR") return pt_br2_campaigns_mag7_spacex_cta_label(inputs)
	if (locale === "tr") return tr_campaigns_mag7_spacex_cta_label(inputs)
	if (locale === "zh-CN") return zh_cn2_campaigns_mag7_spacex_cta_label(inputs)
	if (locale === "zh-HK") return zh_hk2_campaigns_mag7_spacex_cta_label(inputs)
	if (locale === "ko-KR") return ko_kr2_campaigns_mag7_spacex_cta_label(inputs)
	if (locale === "ru-RU") return ru_ru2_campaigns_mag7_spacex_cta_label(inputs)
	return es_419_campaigns_mag7_spacex_cta_label(inputs)
});